import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Button} from "primeng/button";

@Component({
  selector: 'app-alphabet-filter',
  templateUrl: './alphabet-filter.component.html',
  imports: [
    Button
  ],
  standalone: true
})
export class AlphabetFilterComponent implements OnInit {
  @Input() alphabet: string[] = [];
  @Input() groups: Record<string, unknown[]> = {};
  @Input() selectedLetter: string = '';
  @Input() disabled: boolean = false;

  @Output() letterSelected = new EventEmitter<string>();

  ngOnInit(): void {
    // if (!this.disabled) {
    //   const firstAvailable = this.alphabet.find(
    //     (letter) => !this.isLetterDisabled(letter)
    //   );
    //   if (firstAvailable) {
    //     this.selectedLetter = firstAvailable;
    //     this.letterSelected.emit(firstAvailable);
    //   }
    // }
  }

  onLetterClick(letter: string) {
    if (this.disabled || this.isLetterDisabled(letter)) return;
    this.letterSelected.emit(letter);
  }

  isLetterDisabled(letter: string): boolean {
    const list = this.groups?.[letter] as unknown[] | undefined;
    return !list || list.length === 0;
  }
}

